import { render, staticRenderFns } from "./AdicionarProdutoModal.vue?vue&type=template&id=76515969&scoped=true&"
import script from "./AdicionarProdutoModal.vue?vue&type=script&lang=js&"
export * from "./AdicionarProdutoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76515969",
  null
  
)

export default component.exports